export default "__VITE_ASSET__CQ_GVvqj__"